import { useState } from "react";
import { Link } from "react-router-dom";
import { Mug, Asterisk } from "@/components/Motifs";
import { useNavLinks } from "@/components/Nav";

export default function Footer() {
  const [egg, setEgg] = useState(false);
  const links = useNavLinks();
  return (
    <footer data-testid="site-footer" className="bg-[#252122] text-[#FFF9F0] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="font-hand text-2xl md:text-3xl text-[#F7B733]">Some stories are worth waiting for.</div>
            <div className="font-display italic leading-[0.8] text-[34vw] md:text-[15rem] tracking-[-0.05em] mt-2">
              Ni<span className="text-[#FF6657]">G</span>i
            </div>
          </div>
          <div className="md:col-span-4 flex flex-col gap-6 md:items-end md:text-right">
            <button type="button" onClick={() => setEgg(!egg)} data-testid="footer-mug" className="relative w-24 text-[#FFF9F0] floaty" aria-label="A little easter egg">
              <Mug className="w-full" />
              {egg && <span className="absolute -top-8 right-0 whitespace-nowrap bg-[#F7B733] text-[#252122] font-hand text-lg px-3 py-0.5 rotate-[-6deg]">It's happening!!</span>}
            </button>
            <div className="font-display italic text-3xl text-[#F7C9D0]">#MaamlaNiGiHai</div>
            <div className="kicker opacity-70">03.12.2026 · Mumbai · 11:11</div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#FFF9F0]/15 flex flex-wrap gap-x-6 gap-y-3 items-center justify-between">
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {links.map((l) => <Link key={l.to} to={l.to} className="font-ui text-sm opacity-70 hover:opacity-100">{l.label}</Link>)}
          </div>
          <div className="flex items-center gap-2 text-xs opacity-60"><Asterisk size={10} /> Made with love and impeccable timing</div>
        </div>
      </div>
    </footer>
  );
}
